import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import timer from './modules/timer'
import dialogVisible from './modules/dialogVisible'
import preventHangUp from './modules/preventHangUp'
import isViewExam from './modules/isViewExam'
import getters from './getters'
Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app,
        user,
        //测验倒计时
        timer,
        //防挂机验证框
        dialogVisible,
        //防挂机计时器
        preventHangUp,
        isViewExam
    },
    getters
});

export default store;
